import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductAllowedQuantityRequest } from '../../../../_core/quantiProduct.model';
import { ProductAllowedQuantityService } from '../core/product-allowed-quantity.service';
import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'product-changes',
  standalone: true,
  imports: [CommonModule, I18nModule],
  templateUrl: './product-changes.component.html',
  styleUrl: './product-changes.component.scss',
})
export class ProductChangesComponent {
  request$: Observable<ProductAllowedQuantityRequest> = this.productAllowedQuantityService.request$;

  constructor(private productAllowedQuantityService: ProductAllowedQuantityService) {}
}
